const translations = {
    loading : {
        ka: 'იტვირთება ...',
        en: 'Loading ...'
    },
    incorrectLanguage: {
        ka: 'ამ ენაზე ინფორმაციის მოტანა ვერ მოხერხდა',
        en: 'Translation for this language is not available'
    },
    incorrectLocation: {
        ka: 'ასეთი ადგილი ვერ მოიძებნა',
        en: 'Location not found'
    },
    chooseLocation: {
        ka: 'აირჩიეთ ადგილი',
        en: 'Choose a location'
    },
    chooseLanguage: {
        ka: 'აირჩიეთ ენა',
        en: 'Choose a language' 
    },
    dataCanNotbeFetched:{
        ka: 'მონაცემების მოტანა ვერ მოხერხდა',
        en: 'Data can not be fetched'
    },
    temp: {
        ka: 'ტემპერატურა: {value} გრადუსი',
        en: 'Temperature: {value} degrees'
    },           
    feelsLike: {
        ka: 'ქარში მგრძნობელობა: {value} გრადუსი',
        en: 'Feels like: {value} degrees'
    },
    humidity: {
        ka: 'ტენიანობა: {value} პროცენტი',
        en: 'Humidity: {value} percentage'
    },
    pressure: {
        ka: 'წნევა: {value} კილო პასკალი',
        en: 'Pressure: {value} kilopascal'
    },
    windSpeed: {
        ka: 'ქარის სისწრაფე: {value} კმ/სთ',
        en: 'Wind speed: {value} km/h'
    },
    locations: {
        Tsrikvali: {
            ka: 'წირქვალი',
            en: 'Tsrikvali'
        },
        Tbilisi: {
            ka: 'თბილისი',
            en: 'Tbilisi'
        },
        Kutaisi: {
            ka: 'ქუთაისი',
            en: 'Kutaisi'
        }
    },
    dates: {
        weekdays: {
            Monday: { ka: 'ორშაბათი', en: 'Monday'},
            Tuesday: {ka: 'სამშაბათი', en: 'Tuesday'},
            Wednesday: {ka: 'ოთხშაბათი', en: 'Wednesday'},
            Thursday: {ka: 'ხუთშაბათი',en: 'Thursday'},
            Friday: {ka: 'პარასკევი', en: 'Friday'},
            Saturday: {ka: 'შაბათი', en: 'Saturday'},
            Sunday: {ka: 'კვირა', en: 'Sunday'}
        },
        months: {
            January: { ka: 'იანვარი', en: 'January' },
            February: { ka: 'თებერვალი', en: 'February' },
            March: { ka: 'მარტი', en: 'March' },
            April: { ka: 'აპრილი', en: 'April' },
            May: { ka: 'მაისი', en: 'May' },
            June: { ka: 'ივნისი', en: 'June' },
            July: { ka: 'ივლისი', en: 'July' },
            August: { ka: 'აგვისტო', en: 'August' },
            September: { ka: 'სექტემბერი', en: 'September' },
            October: { ka: 'ოქტომბერი', en: 'October' },
            November: { ka: 'ნოემბერი', en: 'November' },
            December: { ka: 'დეკემბერი', en: 'December' }
        }
    }
}

export {translations}